const TYPE = 'REGISTRATION_OPEN';

const action = (on = true) => (dispatch) => dispatch({ type: TYPE, payload: on });

export default { action, TYPE };
